import { render, staticRenderFns } from "./DetalheItensFornecedor.vue?vue&type=template&id=52f61f62&scoped=true"
import script from "./DetalheItensFornecedor.vue?vue&type=script&lang=js"
export * from "./DetalheItensFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f61f62",
  null
  
)

export default component.exports